<template>
  <div>
    <b-button size="sm" variant="primary" @click="clearCache"
      >Clear Cache</b-button
    >
  </div>
</template>

<script>
import adminServices from '../../services/adminServices';

import notification from '@/mixins/notification';

export default {
  name: 'CacheManagement',
  mixins: [notification],
  methods: {
    clearCache() {
      adminServices.appCache().then(() => {
        this.PromptSuccess('Success', 'Cache had been cleared.');
      });
    },
  },
};
</script>

<style scoped></style>